module.exports = "/assets/2a070ef8ac89b04544939316f384af2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OU.png
// module id = 1693
// module chunks = 0